// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__3Noyk","logos":"style_logos__1dUHU","school":"style_school__1VxLZ","user":"style_user__VWedv","info":"style_info__1_CrP","avatar":"style_avatar__jUS9h"};